// 字典相关接口
import request from '@/utils/request'

/**
 * 根据条件分页查询字典数据信息
 * @param params
 * @param data
 * @returns {*}
 */
export function dictPage(params,data) {
    return request({
        url: '/dict/data/page',
        method: 'post',
        params,
        data
    })
}
/**
 * 添加字典数据
 * @param data
 * @returns {*}
 */
export function dictDataAdd(data) {
    return request({
        url: '/dict/data',
        method: 'post',
        data
    })
}
/**
 * 编辑字典数据
 * @param data
 * @returns {*}
 */
export function dictDataEdit(data) {
    return request({
        url: '/dict/data',
        method: 'put',
        data
    })
}
/**
 * 根据ids删除字典数据
 * @param ids
 * @returns {*}
 */
export function dictDataRemove(ids) {
    return request({
        url: '/dict/data/'+ids,
        method: 'delete'
    })
}
/**
 * 添加字典类型
 * @param data
 * @returns {*}
 */
export function dictTypeAdd(data) {
    console.log('提交',JSON.stringify(data))
    return request({
        url: '/dict/type',
        method: 'post',
        data
    })
}

/**
 * 根据字典类型主键编辑字典类型
 * @param data
 * @returns {*}
 */
export function dictTypeEdit(data) {
    return request({
        url: '/dict/type',
        method: 'put',
        data
    })
}

/**
 * 根据id删除字典类型
 * @param id
 * @returns {*}
 */
export function dictTypeRemove(id) {
    return request({
        url: '/dict/type/'+id,
        method: 'delete'
    })
}
/**
 * 根据条件分页查询字典类型信息
 * @param params
 * @param data
 */
export function dictTypePage(params,data) {
    return request({
        url: '/dict/type/page',
        method: 'post',
        params,
        data
    })
}

/**
 * 字典数据列表查询
 * @param params
 * @returns {*}
 */
export function dictDataList(params) {
    return request({
        url: '/dict/public/data/list',
        method: 'get',
        params
    })
}

